import type { ReactNode } from 'react'
import { DeviceContext } from './device-hooks'

/**
 * Detect mobile device by userAgent + maxTouchPoints.
 * This is a static fact about the device — evaluated once at module load.
 *
 * - Standard mobile UAs: iPhone, Android, iPod, etc.
 * - iPadOS: reports "Macintosh" UA but has maxTouchPoints > 0
 * - Touchscreen laptops: have maxTouchPoints > 0 but no mobile UA pattern → excluded
 */
function detectMobileDevice(): boolean {
  if (typeof navigator === 'undefined') return false

  const ua = navigator.userAgent
  const hasMobileUA = /iPhone|iPod|Android|webOS|BlackBerry|Opera Mini|IEMobile/i.test(ua)
  const isIPad = /Macintosh/i.test(ua) && navigator.maxTouchPoints > 0

  return hasMobileUA || isIPad
}

export const IS_MOBILE_DEVICE = detectMobileDevice()

export function DeviceProvider({ children }: { children: ReactNode }) {
  return <DeviceContext value={{ isMobile: IS_MOBILE_DEVICE }}>{children}</DeviceContext>
}
